import React from "react";
import "./FinancingPlanInputPdf.css";
import { formatNumberWithSpaces } from "../../../../utils/Utils";

function FinancingPlanInputPdf({ label, value, icon = "€" }) {
  if (value === 0) return <></>;
  return (
    <div className='pf-pdf-input-container'>
      <div className='pdf-pdf-input-label'>{label}</div>
      <div className='pdf-pdf-input-value'>{formatNumberWithSpaces(value, 1, icon)}</div>
    </div>
  );
}

export default FinancingPlanInputPdf;
